import { render, staticRenderFns } from "./VideoEditorStep.vue?vue&type=template&id=55eda9f0"
import script from "./VideoEditorStep.vue?vue&type=script&lang=js"
export * from "./VideoEditorStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55eda9f0')) {
      api.createRecord('55eda9f0', component.options)
    } else {
      api.reload('55eda9f0', component.options)
    }
    module.hot.accept("./VideoEditorStep.vue?vue&type=template&id=55eda9f0", function () {
      api.rerender('55eda9f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/VideoEditorStep.vue"
export default component.exports